import { render, staticRenderFns } from "./proc-base.vue?vue&type=template&id=3a0ad226"
import script from "./proc-base.vue?vue&type=script&lang=js"
export * from "./proc-base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports